module.exports = __webpack_public_path__ + "img/introduce_title.a252b76e.png";